import React, { useState } from 'react';
import { WithClassname } from '../../types';
import { Button, Popconfirm } from 'antd';
import { blockPhoneNumber, unblockPhoneNumber } from '../../services/api/CustomerService';

export type Props = WithClassname & {
  isBlocked: boolean;
  phoneNumber: string;
  onSuccess: () => void;
};

export default function ToggleBlockPhoneNumberButton({
  isBlocked,
  phoneNumber,
  onSuccess,
  className,
}: Props) {
  const [loading, setLoading] = useState(false);

  const toggleBlock = () => {
    const body = { phone_number: phoneNumber };

    setLoading(true);
    (isBlocked ? unblockPhoneNumber(body) : blockPhoneNumber(body))
      .then(() => onSuccess())
      .catch((error) => console.error('Failed to block phone number', { error }))
      .finally(() => setLoading(false));
  };

  return (
    <Popconfirm
      title={isBlocked ? `Unblock ${phoneNumber}` : `Block ${phoneNumber}`}
      description="Are you sure?"
      onConfirm={toggleBlock}
      okButtonProps={{ danger: true }}
      okText="Yes"
      cancelText="No"
    >
      <Button
        danger
        loading={loading}
        type={isBlocked ? 'default' : 'primary'}
        className={className}
      >
        {isBlocked ? 'Unblock' : 'Block'}
      </Button>
    </Popconfirm>
  );
}
